// src/components/reports/preview/AllTimeEntriesPreview.js

import React from 'react';
import { formatDate, formatTime, formatDuration } from '../../../models/TimeEntryReportModel';

/**
 * Preview component for All Time Entries report type
 * @param {Object} props - Component props
 * @param {Array} props.data - Report data entries
 * @param {boolean} props.isPreview - Whether this is a limited preview
 * @param {number} props.previewLimit - Maximum number of rows to show in preview
 */
const AllTimeEntriesPreview = ({ data, isPreview = true, previewLimit = 10 }) => {
  // Determine how many rows to display
  const displayData = isPreview ? data.slice(0, previewLimit) : data;
  
  // Calculate total work hours for all entries
  const totalWork = data.reduce((sum, entry) => sum + entry.workDuration, 0);
  
  return (
    <div className="report-preview all-time-entries-preview">
      <div className="report-preview-scroll">
        <table className="report-table">
          <thead>
            <tr>
              <th className="date-col">Date</th>
              <th className="staff-col">Staff</th>
              <th className="session-col">Session</th>
              <th className="time-col">Start</th>
              <th className="time-col">End</th>
              <th className="duration-col">Total Hours</th>
            </tr>
          </thead>
          
          <tbody>
            {displayData.map((entry, index) => (
              <tr key={entry.id || index} className={index % 2 === 1 ? 'alternate-row' : ''}>
                <td>{formatDate(entry.date)}</td>
                <td>{entry.staffName}</td>
                <td>{entry.sessionId || '1'}</td>
                <td>{formatTime(entry.clockIn)}</td>
                <td>{formatTime(entry.clockOut)}</td>
                <td>{formatDuration(entry.workDuration)}</td>
              </tr>
            ))}
            
            {/* Show totals row */}
            <tr className="totals-row">
              <td colSpan={2}><strong>TOTAL</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td><strong>{formatDuration(totalWork)}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
      
      {/* Show message if there are more entries than shown in preview */}
      {isPreview && data.length > previewLimit && (
        <div className="preview-more-message">
          ... and {data.length - previewLimit} more entries
        </div>
      )}
    </div>
  );
};

export default AllTimeEntriesPreview;